export function formatMoney( Money ){

    const numericValue = Money.replace(/\D/g, "");
    const valorFormated = ( parseInt( numericValue, 10 ) / 100 ).toFixed( 2 )
    return valorFormated;

}